<template>
    <article
        v-if="news"
        class="tw-flex tw-h-full tw-cursor-pointer tw-flex-col tw-text-start"
        :class="{ 'tw-bg-white tw-rounded-3xl tw-shadow-lg tw-pb-4': card }"
        @click="openNews">
        <img
            alt=""
            class="tw-aspect-[2/1] tw-object-cover tw-object-center"
            :class="{ 'tw-rounded-3xl': !card, 'tw-rounded-t-3xl': card }"
            :src="news.getImage('medium')" />
        <p class="tw-mt-6 tw-text-sm tw-font-light tw-text-dark" :class="{ 'tw-px-4': card }">{{ news.getPublishDate() }}</p>
        <h4
            class="tw-mt-3 tw-line-clamp-2 tw-min-h-[3em] tw-text-lg tw-font-semibold xl:tw-text-base"
            :class="{ 'tw-px-4': card }"
            v-html="news.title"></h4>
        <div
            class="tw-line-clamp-3 tw-text-sm xl:tw-mt-3"
            :class="{ 'tw-px-4': card }"
            v-html="news.description"></div>
        <!-- <div class="tw-mt-auto">
            <v-btn
                class="tw-mt-3 tw-h-10 tw-px-4 max-md:tw-ms-auto md:tw-me-auto xl:tw-mt-6"
                color="blue"
                rounded="pill"
                :to="`/news/${news.documentId}`">
                Ler mais
            </v-btn>
        </div> -->
    </article>
</template>

<script setup lang="ts">
    import { News, useNews } from '@/composables/useNews';
    import { useRouter } from 'vue-router';
    const props = defineProps<{
        news: News;
        card?: boolean;
    }>();

    const news = computed(() => {
        return props.news ? useNews(props.news) : null;
    });

    const $router = useRouter();
    const openNews = () => {
        $router.push({ name: 'NewsDetail', params: { documentId: news.value?.slug as string } });
    };
</script>

<style scoped></style>
